// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';
import { get } from 'lodash';

import { Icon } from '@zapier/common-components';

import LoadingStar from 'web-ssr/app/common/components/LoadingStar';
import SearchBox from 'web-ssr/app/common/components/SearchBox';
import ServiceLogo from 'web-ssr/app/services/components/ServiceLogo';
import ServicesSearchDropdown from 'web-ssr/app/services/components/ServicesSearch/ServicesSearchDropdown';
import 'web-ssr/app/services/components/ServicesSearch/ServicesSearch.scss';

import type { KindType } from 'web-ssr/app/common/types';
import type {
  appInfoFragment,
  publicAppSearchQuery_getAppsByNameContains_edges,
} from 'web-ssr/graphql/types';

const bem = bemify('services-search');

type Props = {
  className?: string,
  isDropdownOpen: boolean,
  isLoading: boolean,
  onChange: (value: string) => void,
  onFocus: () => void,
  onSelectService: (service: appInfoFragment) => void,
  placeholder?: string,
  selectedService: ?appInfoFragment,
  apps: Array<publicAppSearchQuery_getAppsByNameContains_edges>,
  value: string,
  skipQuery: boolean,
  kind?: KindType,
  inputRef?: any,
};

const ServicesSearch = (props: Props) => {
  const {
    className,
    isDropdownOpen,
    isLoading,
    onChange,
    onFocus,
    onSelectService,
    placeholder,
    selectedService,
    apps,
    value,
    skipQuery,
    kind,
    inputRef,
  } = props;

  return (
    <div className={bem(className, toModifiers(kind))}>
      <SearchBox
        inputRef={inputRef}
        isLoading={isLoading}
        kind={kind}
        name="search"
        onChange={onChange}
        onFocus={onFocus}
        placeholder={placeholder}
        renderIcon={iconProps => {
          if (isLoading) {
            return <LoadingStar className={iconProps.className} />;
          }

          if (selectedService) {
            const serviceName = get(selectedService, ['name']);
            const serviceImages = get(selectedService, ['images'], {});

            return (
              <ServiceLogo
                className={iconProps.className}
                images={serviceImages}
                serviceName={serviceName}
              />
            );
          }

          return (
            <Icon
              className={bem(iconProps.className)}
              name="search"
              size={18}
            />
          );
        }}
        showClearButton={true}
        type="text"
        value={value}
      />
      <ServicesSearchDropdown
        apps={apps}
        isDropdownOpen={
          // The dropdown should not appear when the search value is empty or
          // the search box is making an async query
          !isLoading && !skipQuery && isDropdownOpen
        }
        onSelectService={onSelectService}
      />
    </div>
  );
};

export default ServicesSearch;
